import React, { useMemo, useState, ReactNode, useEffect } from "react";
import { UserContext } from "../context/UserContext";

export interface IUserProvider {
    children: ReactNode;
}

export const UserProvider = ({ children }: IUserProvider) => {
    const [user, setUser] = useState(() => localStorage.getItem("user") || "");
    useEffect(() => {
        if (user) {
            localStorage.setItem("user", user);
        }
    }, [user]);

    const defaultProps = useMemo(
        () => ({
            user,
            setUser,
        }),
        [user],
    );
    return <UserContext value={defaultProps}>{children}</UserContext>;
};
